import React from 'react';
import coursesClient from '../../logic/courses';
import { IonSpinner } from '@ionic/react';
import Collapsible from 'react-collapsible';
import CollapsibleTrigger from '../UI/CollapsibleTrigger';
import dl from '../../utils/device-language';
import { useTranslation } from 'react-i18next';
import { useFilters } from '../../utils/contexts/filters-context';
import { useUser } from '../../utils/contexts/user-context';
import Dishes from './Dishes';

export default function TastingList(props) {
    const { course, index, tastingMenu } = props;

    const [products, setProducts] = React.useState([]);
    const [isLoading, setLoading] = React.useState(true);
    const [open, setOpen] = React.useState(false);

    const { i18n } = useTranslation();
    const { filters, filtered } = useFilters();
    const { user } = useUser();

    async function onOpening() {
        // populate products with course products
        // products are loaded from courses logic
        console.log("on opening");

        let clientCourse;

        let language = process.env.REACT_APP_LANGUAGESELECTOR === "true" ? i18n.language : dl.getApiLanguage();


        if (user) {
            if (filtered) {
                console.log("TL", user);
                clientCourse = await coursesClient.doGetUserFiltersTastingMenu(language, course.id, tastingMenu.id, user.user_token);
            } else {
                clientCourse = await coursesClient.doGetTastingMenu(language, course.id, tastingMenu.id);
            }
        } else {
            clientCourse = await coursesClient.doGetTastingMenu(language, course.id, tastingMenu.id);
        }

        setProducts(clientCourse.dishes);
        setLoading(false);
    }

    React.useEffect(() => { setOpen(false); }, [filters]);

    return (
        <Collapsible
            className="tasting-menu row"
            tabIndex={index}
            trigger={<CollapsibleTrigger index={index} trigger={course} setOpen={setOpen}></CollapsibleTrigger>}
            triggerWhenOpen={<CollapsibleTrigger index={index} trigger={course} opened setOpen={setOpen}></CollapsibleTrigger>}
            onTriggerOpening={onOpening}
            open={open}>
            <div>
                {isLoading ?
                    <IonSpinner name="dots" /> :
                    < Dishes dishes={products} index={index} isTastingMenu={tastingMenu !== undefined && tastingMenu !== null} /> // TODO: check
                }
            </div>
        </Collapsible>
    );
}
